import get from 'growth-payments-core/object/get';
import { CPQ_QUOTES_GATE, KYC_EMBEDDED_FALLBACK_EXPERIENCE, OPTIMIZE_POST_ENROLL_M2_M3, PRE_APPROVED, PRODUCT_BUILDER, SHARED_TASKS_COMPONENTS_MIGRATION } from '../constants/gates';
import { useSet } from '../set/useSet';
import { getAuth, useAuth } from './user';
export const useGates = () => {
  const [userInfo] = useAuth();
  const gatesSet = useSet(get(userInfo, 'gates'));
  return gatesSet;
};
export const getGates = () => {
  return get(getAuth(), 'gates');
};
export const useIsUngated = (...gatesToCheck) => {
  const gates = useGates();
  return gatesToCheck.every(gate => gates.has(gate));
};
export const useIsUngatedForPreApproval = () => useIsUngated(PRE_APPROVED);
export const useIsUngatedForOptimizePostEnrollM2M3 = () => useIsUngated(OPTIMIZE_POST_ENROLL_M2_M3);
export const useIsUngatedForKycEmbeddedFallbackExperience = () => useIsUngated(KYC_EMBEDDED_FALLBACK_EXPERIENCE);
export const useIsUngatedForProductBuilder = () => useIsUngated(PRODUCT_BUILDER);
export const useIsUngatedForCpqQuotes = () => useIsUngated(CPQ_QUOTES_GATE);
export const useIsUngatedForSharedTasksComponentsMigration = () => useIsUngated(SHARED_TASKS_COMPONENTS_MIGRATION);